import React from 'react'
import { Grid, Box } from '@mui/system';
import MaterialSelect from '../../../../../components/MaterialSelect';
import MaterialTypography from '../../../../../components/MaterialTypography';
import { List, ListItem, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import FolderIcon from "@mui/icons-material/Folder";

const Sidebar = ({ project, handleProjectChange, projectList, projectModules, anchorEl, handleAddTestCase, open, handleMenuClose, handleListClick }) => {

    return (
        <Box
            role="navigation"
            aria-label="File explorer sidebar"
            sx={{
                backgroundColor: 'background.paper',
                width: { xs: '100%', sm: '250px' },
                height: '78vh',
                padding: 1,
                border: 1,
                borderColor: 'divider',
                overflow: 'auto',
            }}
        >
            <Grid container direction='column' spacing={2}>
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        <MaterialTypography variant='caption' color='secondary'>Project List</MaterialTypography>
                        <MaterialSelect
                            label="Select Project"
                            value={project}
                            size="small"
                            options={projectList.map((project) => {
                                return { label: project.label, value: project.value };
                            })}
                            onChange={handleProjectChange}
                        />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                    {projectModules && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', overflow: 'hidden' }}>
                            <MaterialTypography variant='caption' fontWeight='bold' color='dark'>{projectModules.name}</MaterialTypography>
                            <Box>
                                <List>
                                    {projectModules.subModules?.map((subModule) => (
                                        <ListItem
                                            key={subModule.id}
                                            onClick={() => handleListClick(subModule.id)}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            <ListItemIcon sx={{ minWidth: 26, mr: 0 }}>
                                                <FolderIcon fontSize="small" color="dark" />
                                            </ListItemIcon>
                                            <ListItemText primary={subModule.name}
                                                primaryTypographyProps={{
                                                    fontSize: "0.75rem",
                                                    marginTop: '2px'
                                                }}
                                            />
                                        </ListItem>
                                    ))}
                                </List>

                                <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}
                                    sx={{
                                        '& .MuiPaper-root': {
                                            minWidth: 120,
                                            paddingY: 0.5,
                                        },
                                        '& .MuiMenuItem-root': {
                                            fontSize: '0.8rem',
                                            paddingY: 0.5,
                                            paddingX: 1.5,
                                        },
                                    }}>
                                    <MenuItem onClick={handleAddTestCase}>Add Test Case</MenuItem>
                                </Menu>
                            </Box>
                        </Box>
                    )}
                </Grid>
            </Grid>
        </Box>
    )
}

export default Sidebar
